// src/js/redesignInfoBar.js
// Accepts optional root element for scoped initialization
export function redesignInfoBar(root) {
  const infoBars = root
    ? root.querySelectorAll(".redesign-info-bar")
    : document.querySelectorAll(".redesign-info-bar");
  infoBars.forEach((infoBar) => {
    // Prevent duplicate event listeners
    if (infoBar.__redesignInfoBarInitialized) return;
    infoBar.__redesignInfoBarInitialized = true;
    const toggle = infoBar.querySelector("[data-info-bar-toggle]");
    if (!toggle) return;
    const content = infoBar.querySelector(".info-bar-content-wrapper");
    toggle.addEventListener("click", () => {
      const expanded = toggle.getAttribute("aria-expanded") === "true";
      toggle.setAttribute("aria-expanded", String(!expanded));
      content.classList.toggle("info-bar-open", !expanded);
    });
  });
}
